exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-view-item .grid-view-img[data-v-1ab6bfc5] {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  transition: 0.35s;\n}[dir] .grid-view-item .grid-view-img[data-v-1ab6bfc5] {\n  -webkit-transition: 0.35s;\n}\n.grid-view-item[data-v-1ab6bfc5]:hover {\n  -webkit-transform: translateY(-5px);\n  -webkit-box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);\n}\n[dir] .grid-view-item[data-v-1ab6bfc5]:hover {\n          transform: translateY(-5px);\n          box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);\n}\n.grid-view-item:hover .grid-view-img[data-v-1ab6bfc5] {\n  opacity: 0.9;\n}", ""]);

// exports
